import styled from 'styled-components/macro';
import { media, neutral, shadow } from '../../../theme/tokens';

export const ChatContainer = styled.section`
  display: grid;
  grid-template-rows: min-content auto;
  grid-template-areas: 'staffWhiteboard' 'chat';
  background: ${({ theme }) => theme.chatBackground};
  position: fixed;
  right: 0;
  /* sits under the mobile top nav */
  top: 8.5vh;
  width: 100%;
  min-width: 325px;
  height: calc(100% - 8.5vh);
  z-index: 20;

  ${media.md`
    top: 0;
    width: 25vw;
    height: 100%;
    border-left: 1px solid ${neutral.border};
    box-shadow: ${shadow.lg};
  `}
`;

export * from '../../common/elements/Staff';
